import React, { useContext, useEffect, useState } from 'react';
import { getCategoryNameFromPathname } from '../LoggerFactory/BiAnalyticsLogger/events/utils';
import { useHistory, useLocation } from 'react-router';
import { StoreContext } from '../appContext/StoreProvider';
import {
  isBackOffice,
  isBranch,
  isLocalViewer,
  parseQueryString,
} from '../../utils/locationUtils';
import { getFirstCategoryUrlFormat } from '../components/App/utils';

export const useMenu = () => {
  const location = useLocation();
  const history = useHistory();
  const { store } = useContext(StoreContext);
  const [keyToOpen, setKeyToOpen] = useState('');
  const [openedKeys, setOpenedKeys] = useState([]);

  const updateCategoryToOpenFromPathname = () => {
    if (location.pathname) {
      const categoryName = getCategoryNameFromPathname(
        location.pathname,
        store,
      );
      setKeyToOpen(`/${categoryName}`);
      setOpenedKeys([`/${categoryName}`, ...openedKeys]);
    }
  };

  const shouldOpenTree = (key) => keyToOpen === key;

  const toggleMenuKeys = (selectedKey) => {
    const initKeys = [...openedKeys];
    const shouldCloseMenu = openedKeys.includes(selectedKey);
    let newOpenedMenu = [];
    if (shouldCloseMenu) {
      newOpenedMenu = openedKeys.filter((key) => key !== selectedKey);
    } else {
      newOpenedMenu = [...initKeys, selectedKey];
    }
    setOpenedKeys(newOpenedMenu);
  };

  const toggleTreeNavigationMenu = (selectedKey) => {
    if (keyToOpen === selectedKey) {
      setKeyToOpen('');
      return;
    }
    setKeyToOpen(selectedKey);
  };

  useEffect(() => {
    if (location.pathname === '/') {
      const firstCategoryUrlFormat = getFirstCategoryUrlFormat(store);
      toggleMenuKeys(firstCategoryUrlFormat);
      toggleTreeNavigationMenu(firstCategoryUrlFormat);

      const { branch, localViewerId } = parseQueryString(location.search);
      if (isBranch(location)) {
        const backofficeQueryParams = `${
          isBackOffice(location) ? '&& backoffice=true' : ''
        }`;
        history.replace(
          `${firstCategoryUrlFormat}?branch=${branch}${backofficeQueryParams}`,
        );
      } else if (isLocalViewer(location)) {
        history.replace(
          `${firstCategoryUrlFormat}?localViewerId=${localViewerId}`,
        );
      } else if (isBackOffice(location)) {
        history.replace(`${firstCategoryUrlFormat}?backoffice=true`);
      } else {
        history.replace(firstCategoryUrlFormat);
      }
    } else {
      updateCategoryToOpenFromPathname();
    }
  }, []);

  React.useEffect(() => {
    if (keyToOpen === '') {
      return;
    }
    updateCategoryToOpenFromPathname();
  }, [location]);

  return {
    toggleTreeNavigationMenu,
    toggleMenuKeys,
    shouldOpenTree,
    openedKeys,
  };
};
